import { useFeatureValue } from '@/hooks/useFeatureValue';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

export const useIosFetchBridgeToggle = () => {
  return useFeatureValue(FeatureConfigKeys.IOS_FETCH_BRIDGE_ENABLED, false);
};
